import styled from 'styled-components';

export const GraphContainer = styled.div`
  height: 260px;
  width: 100%;

  .tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent;
  }
`;
